import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { ToasterService } from 'angular2-toaster';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { EditalDTO } from 'src/app/model/dto/edital.dto';
import { DataTransferService } from 'src/app/service/data-transfer.service';
import { DocumentoService } from 'src/app/service/documento.service';
import { EditalService } from 'src/app/service/edital/edital.service';
import { RequerimentoService } from 'src/app/service/requerimento.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { MaskUtil } from '../../utils/mask-util';

export interface Food {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-solicitacao',
  templateUrl: './solicitacao.component.html',
  styleUrls: ['./solicitacao.component.css']
})
export class SolicitacaoComponent implements OnInit {

  cpfvalido: boolean;
  mask: any;

  msgAlertaError:string;
  alertaError: boolean = false; 
  dataDistribuicao: string;
  nomeEdital: string;
  checked = false;
  formSolicitacao: FormGroup;
  editais: EditalDTO[] = [];
  editalTxt: boolean;
  precatoriomask = MaskUtil.precatoriomask;
  idEdital: number;
  dtfim:string;
  @BlockUI() blocker: NgBlockUI;

  constructor(private fb: FormBuilder, 
    private router: Router, 
    private requerimentoService: RequerimentoService,
    private editalService: EditalService,
    private documentoService: DocumentoService,
    private toastService: ToasterService,
    private dataTransfer: DataTransferService,
    public local: LocalStorageService) { }

  ngOnInit() {
    this.montarForm();
  }

  montarForm() {
    this.formSolicitacao = this.fb.group({
      cpfCnpj: new FormControl(''),
      nrPrecatorio: new FormControl(''),
      edital: new FormControl(''),
    });
    this.editalService.buscarEditaisAtivos(0).subscribe(({ data }) => {
      this.editais = data;
    });
  }
  solicitar() {
    this.blocker.start('Processando...');

    if(!this.validarCpfCnpj(this.formSolicitacao.get('cpfCnpj').value.replace(/[^0-9a-zA-Z]+/g,''))) {
      this.toastService.pop('warning', 'CPF ou CNPJ inválido');
      this.blocker.stop();
      return;
    }
    const solicitacao = {
      cpfCnpj : this.formSolicitacao.get('cpfCnpj').value.replace(/[^0-9a-zA-Z]+/g,''),
      nrPrecatorio: this.formSolicitacao.get('nrPrecatorio').value.replace(/[^0-9a-zA-Z]+/g,''),
      dataDistribuicao: this.formSolicitacao.get('edital').value.id
    }
    this.requerimentoService.verificarRequerimento(solicitacao.cpfCnpj, solicitacao.nrPrecatorio, solicitacao.dataDistribuicao).subscribe(({data, mensagem}) => {
      if (mensagem === null) {
        data.credor.cpfCnpjRequerente = this.formSolicitacao.get('cpfCnpj').value.replace(/[^0-9a-zA-Z]+/g,'');
        
        console.log( data.credor.cpfCnpjRequerente);
        data.edital = new EditalDTO(); 
        data.edital = this.formSolicitacao.get('edital').value;
        this.dataTransfer.setData(data);
        this.local.set('rotaAnterior', 'solicitacao');
        this.router.navigate(['formulario']);
        this.blocker.stop();
      } else {
        this.blocker.stop();
        //this.alertaError = true;
        if (data !== null) {
          //this.msgAlertaError = mensagem +' ' + data.numFormulario;
          Swal.fire({
            text: mensagem +' ' + data.numFormulario,
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            },
            icon: 'info',
          });
        } else {
          //this.msgAlertaError = mensagem;
          Swal.fire({
            text: mensagem,
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            },
            icon: 'info',
          });
        }
      }
    });

  }


  public cpfcnpjmask = function (rawValue) {

    var numbers = rawValue.match(/\d/g);
    var numberLength = 0;
    if (numbers) {
      numberLength = numbers.join('').length;
    }
    if (numberLength <= 11) {
      return [
        /[0-9]/,/[0-9]/,/[0-9]/,'.', /[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/, /[0-9]/,'-',/[0-9]/,/[0-9]/,];
    } else {
      return [
        /[0-9]/, /[0-9]/, '.',/[0-9]/,/[0-9]/, /[0-9]/,'.',/[0-9]/,/[0-9]/, /[0-9]/,'/',/[0-9]/, /[0-9]/,/[0-9]/,/[0-9]/, '-',
        /[0-9]/,/[0-9]/,];
    }
  };

  download() {
    this.documentoService.downloadTermo(this.idEdital)
    .subscribe(data => this.downloadFile(data),
    error => {
      if (error.status == 400) {
        Swal.fire({
          text:  'Termo de Adesão não encontrado',
          icon: 'error',
        });  
      }
    });
   }
  
   downloadFile(data) {
    const newBlob = new Blob([data], { type: "application/pdf" });
    const url= window.URL.createObjectURL(newBlob);
    window.open(url);
  }

  cancelar() {
    this.formSolicitacao.get('cpfCnpj').setValue('');
    this.formSolicitacao.get('nrPrecatorio').setValue('')
  }

  habilitarTexto() {
    this.editalTxt = true;
  }

  configurarTexto(edital: EditalDTO) {
    this.nomeEdital = edital.nomeEdital;
    this.dataDistribuicao = edital.dataDistribuicao
    this.idEdital = edital.id;
    this.dtfim = edital.periodoFim;
  }

  private validarCpfCnpj(value: string) {
    console.log(value.length);
    if(value.length  === 11) {
      return MaskUtil.validar_cpf(value);
    } 
    if(value.length  === 14) {
      return MaskUtil.validar_cnpj(value);
    } 
  }
  

}
